import { render } from "./ImgSvg.vue?vue&type=template&id=30aedf56"
import script from "./ImgSvg.vue?vue&type=script&lang=js"
export * from "./ImgSvg.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__